// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getQuarter as fn } from "../getQuarter.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getQuarterWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getQuarterWithOptions;
